/**
 * 変更履歴画面を別ウィンドウで開く / 閉じるための部品 (Issue #890)。
 *
 * 現場WG画面と同じタブで履歴へ遷移すると、戻ったときに画面内の状態 (選択中のタブ、
 * 絞り込み、スクロール位置、開いているモーダル) が失われる。履歴を別ウィンドウで開けば、
 * 遷移元の画面はブラウザがそのまま保持する。
 *
 * - `<a target="_blank">` は暗黙に noopener になり、開いた側が閉じる手段 (`window.close()`) を
 *   確実には持てない。スクリプトから `window.open` で開いたウィンドウは閉じられるので、
 *   リンクのクリックではこちらを使う (同一オリジンなので opener を残してよい)。
 * - 履歴側が「自分は遷移元から開かれた」と知る手段は `window.opener` だけ。
 *   メールのリンクなどで直接開かれたウィンドウでは null になる。
 */

/** 履歴ウィンドウの名前。同じ名前を使い、押すたびにウィンドウが増えないようにする */
export const MASTER_HISTORY_WINDOW_NAME = 'oba-core-master-history';

/**
 * 履歴を別ウィンドウで開く。
 *
 * @returns 開けたら true。ポップアップがブロックされたなどで開けなければ false
 *   (呼び出し側は同一タブでの遷移にフォールバックする)。
 */
export function openMasterHistoryWindow(path: string): boolean {
  try {
    const opened = window.open(path, MASTER_HISTORY_WINDOW_NAME);
    if (!opened) return false;
    opened.focus();
    return true;
  } catch {
    return false;
  }
}

/** このウィンドウが、遷移元の現場WG画面から開かれたものか */
export function isOpenedFromSourceWindow(): boolean {
  try {
    return window.opener != null && !(window.opener as Window).closed;
  } catch {
    return false;
  }
}

/**
 * 履歴へのリンクのクリックを別ウィンドウ表示に振り替える。
 *
 * 修飾キー付き・中/右クリックは、ブラウザ標準の「新しいタブで開く」などに任せる。
 * 別ウィンドウを開けなかったときは何もせず、リンク本来の同一タブ遷移に任せる
 * (その場合、履歴側は `window.opener` が無いので「遷移元へ戻る」ボタンを出す)。
 */
export function openMasterHistoryInNewWindow(
  event: Pick<
    React.MouseEvent,
    'button' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'preventDefault'
  >,
  path: string,
): void {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }
  if (openMasterHistoryWindow(path)) {
    event.preventDefault();
  }
}
